import { Auth as SupabaseAuth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { supabase } from "@/integrations/supabase/client";

const SignInForm = () => {
  return (
    <SupabaseAuth 
      supabaseClient={supabase}
      appearance={{
        theme: ThemeSupa,
        variables: {
          default: {
            colors: {
              brand: '#2D5A27',
              brandAccent: '#2D5A27',
            },
          },
        },
      }}
      providers={[]}
      view="sign_in"
    />
  );
};

export default SignInForm;